import React, { memo } from 'react'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import { FormIf } from 'transfix-form/components/FormIf'
import Grid from 'transfix-ui/core/Grid'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes, IEquipmentTypes } from 'types/graphqlTypes'
import {
  DOOR_OPTIONS,
  FLOOR_OPTIONS,
  ROOF_OPTIONS,
  WALL_OPTIONS,
} from 'apps/marketplace/utils/constants/graphqlEquipment'
import { useCreateShipmentFormContext } from '../../../context'

export interface IAdditionalOptionsFormSectionProps {}

const AdditionalOptionsFormSection = memo<IAdditionalOptionsFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control } = useCreateShipmentFormContext()
  return (
    <Grid container spacing={1}>
      <Typography variant='subtitle1'>Additional Options</Typography>
      <Grid item xs={12}>
        <ControlledSelect
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.roof_type}`}
          SelectProps={{
            placeholder: 'Roof Type',
            dataTest: 'roof-type-field',
            options: ROOF_OPTIONS,
          }}
        />
      </Grid>
      <FormIf control={control} name='equipment' when={IEquipmentTypes.dry_van}>
        <Grid item xs={12}>
          <ControlledSelect
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.wall_type}`}
            SelectProps={{
              placeholder: 'Wall Type',
              dataTest: 'wall-type-field',
              options: WALL_OPTIONS,
            }}
          />
        </Grid>
      </FormIf>
      <FormIf control={control} name='equipment' when={IEquipmentTypes.dry_van}>
        <Grid item xs={12}>
          <ControlledSelect
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.floor_type}`}
            SelectProps={{
              placeholder: 'Floor Type',
              dataTest: 'floor-type-field',
              options: FLOOR_OPTIONS,
            }}
          />
        </Grid>
      </FormIf>
      <Grid item xs={12}>
        <ControlledSelect
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.door_type}`}
          SelectProps={{
            placeholder: 'Door Type',
            dataTest: 'door-type-field',
            options: DOOR_OPTIONS,
          }}
        />
      </Grid>
    </Grid>
  )
})

export default AdditionalOptionsFormSection
